module.exports = __webpack_public_path__ + "static/media/72.88476773.png";